import React from 'react';
import { FacebookIcon, GlobeIcon, InstagramIcon, LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { useLanguage } from '../../contexts/LanguageContext';
import { email, phones, website } from '../../data/contact';
const socials = [{
  label: 'LinkedIn',
  Icon: LinkedinIcon,
  href: 'https://linkedin.com'
}, {
  label: 'Facebook',
  Icon: FacebookIcon,
  href: 'https://facebook.com'
}, {
  label: 'Instagram',
  Icon: InstagramIcon,
  href: 'https://instagram.com'
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="border-t border-white/10 bg-ink pb-10 pt-20" data-id="element-103" data-mp="1w8271td5qjb8">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-104" data-mp="1reh89z3qplaz">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr_1fr]" data-id="element-105" data-mp="13peretgxjwhj">
          <div data-id="element-106" data-mp="13nbq3dabugxi">
            <Logo variant="light" data-id="element-107" data-mp="yqleb25k27hw" />
            <p className="mt-6 max-w-[300px] text-[14px] leading-relaxed text-white/55" data-id="element-108" data-mp="ypineu88g51z">
              {t.footer.tagline}
            </p>
            <div className="mt-7 overflow-hidden rounded-4xl border border-white/10 shadow-lift" data-id="element-109" data-mp="1efzkyt7t66d4">
              <img src="https://cdn.magicpatterns.com/uploads/9w4R1e9Qm7iDRLUBkjiyMC/WhatsApp_Image_2026-08-19_at_9.39.32_AM.jpg" alt={t.footer.teamPhotoAlt} className="h-[260px] w-full object-cover transition-transform duration-700 hover:scale-[1.04] sm:h-[320px] lg:h-[300px]" data-id="element-110" data-mp="1ihkt619edwgz" />
            </div>
            <ul className="mt-7 flex items-center gap-3" data-id="element-111" data-mp="vlavzg0gc6jl">
              {socials.map(({
              label,
              Icon,
              href
            }) => <li key={label} data-id="element-112" data-mp="14jmrnwg6duiw">
                  <a href={href} aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/12 text-white/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand hover:bg-brand hover:text-white" data-id="element-113" data-mp="14il5avtplllv">
                    <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-114" data-mp="2kxd0thm5j8ze" />
                  </a>
                </li>)}
            </ul>
            <LanguageSwitcher variant="dark" className="mt-7 w-fit" data-id="element-115" data-mp="1v8fo54urpmt8" />
          </div>

          <div data-id="element-116" data-mp="1qa4fgxg7licl">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-117" data-mp="1qanxsf9ru8r5">
              {t.footer.floridaOffice}
            </h3>
            <p className="mt-5 flex gap-2.5 text-[14px] leading-relaxed text-white/70" data-id="element-118" data-mp="208k8j5ysr1oq">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-119" data-mp="1cj9b9ygnnpfc" />
              <span data-id="element-120" data-mp="17kobu19899ry">
                {t.footer.floridaAddress[0]}
                <br data-id="element-121" data-mp="17m93nj45qem4" />
                {t.footer.floridaAddress[1]}
              </span>
            </p>
            <h3 className="mt-8 text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-122" data-mp="1mbf3986wq6uj">
              {t.footer.newYorkOffice}
            </h3>
            <p className="mt-5 flex gap-2.5 text-[14px] leading-relaxed text-white/70" data-id="element-123" data-mp="trzqgt1fpe8g">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-124" data-mp="ouq4xoh61mpw" />
              <span data-id="element-125" data-mp="30gryvszovwhi">
                {t.footer.newYorkAddress[0]}
                <br data-id="element-126" data-mp="30fgups2c0mpv" />
                {t.footer.newYorkAddress[1]}
              </span>
            </p>
          </div>

          <div data-id="element-127" data-mp="2qjduirr1iy5k">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-128" data-mp="2qjvo1gmbiy9s">
              {t.footer.contact}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-129" data-mp="2vigtbugfg853">
              {phones.map(phone => <li key={phone.href} data-id="element-130" data-mp="3j8t7hn29n144">
                  <a href={phone.href} className="flex items-center gap-2.5 text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-131" data-mp="3j5osdun9ikyo">
                    <PhoneIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-132" data-mp="3a7mnv54bla6n" />
                    {phone.display}
                  </a>
                </li>)}
              <li data-id="element-133" data-mp="3earlat9jmlof">
                <a href={`mailto:${email}`} className="flex items-start gap-2.5 break-all text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-134" data-mp="1yry2ujamml8h">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-135" data-mp="22v2zi580zsp7" />
                  {email}
                </a>
              </li>
              <li data-id="element-136" data-mp="2e9fqujc6p4k0">
                <a href={website.href} className="flex items-center gap-2.5 text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-137" data-mp="2e8wklzvwc4lt">
                  <GlobeIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-138" data-mp="298s5oeamzhxp" />
                  {website.display}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-139" data-mp="31yqx2gcazr5j">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-140" data-mp="31x62wrtwia87">
              {t.footer.explore}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-141" data-mp="2s0ktzvergez3">
              {t.nav.links.map(link => <li key={link.href} data-id="element-142" data-mp="2o010d1tebthp">
                  <a href={link.href} className="text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-143" data-mp="2nypo0dlvxdez">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-144" data-mp="1ckcaa1kuieco">
                <a href="#consultation" className="text-[14px] font-semibold text-brand transition-colors hover:text-white" data-id="element-145" data-mp="1cjsqsgfjrhwj">
                  {t.footer.freeConsultation}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-146" data-mp="13hu3vnu5o56">
          <p className="text-[13px] text-white/45" data-id="element-147" data-mp="5uztifa7ngo1">
            © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p className="text-[13px] text-white/45" data-id="element-148" data-mp="asrltaerp4sr">{t.footer.offices}</p>
        </div>
      </div>
    </footer>;
}